export default "/static/assets/monitor-trend.196ac3fd3b505c5a9fbe78e8ed0e970a.svg";